import "../assets/NcAppNavigationToggle-2bc73ee8.css";
import o from "../Components/NcButton.mjs";
import { t as l } from "./l10n-1b905a9a.mjs";
import { n as i } from "./_plugin-vue2_normalizer-71e2aa87.mjs";
const r = {
  name: "MenuIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var s = function() {
  var t = this, e = t._self._c;
  return e("span", t._b({ staticClass: "material-design-icon menu-icon", attrs: { "aria-hidden": !t.title, "aria-label": t.title, role: "img" }, on: { click: function(n) {
    return t.$emit("click", n);
  } } }, "span", t.$attrs, !1), [e("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [e("path", { attrs: { d: "M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" } }, [t.title ? e("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, c = [], _ = /* @__PURE__ */ i(
  r,
  s,
  c,
  !1,
  null,
  null,
  null,
  null
);
const p = _.exports, u = {
  name: "MenuOpenIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var m = function() {
  var t = this, e = t._self._c;
  return e("span", t._b({ staticClass: "material-design-icon menu-open-icon", attrs: { "aria-hidden": !t.title, "aria-label": t.title, role: "img" }, on: { click: function(n) {
    return t.$emit("click", n);
  } } }, "span", t.$attrs, !1), [e("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [e("path", { attrs: { d: "M21,15.61L19.59,17L14.58,12L19.59,7L21,8.39L17.44,12L21,15.61M3,6H16V8H3V6M3,13V11H13V13H3M3,18V16H16V18H3Z" } }, [t.title ? e("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, f = [], g = /* @__PURE__ */ i(
  u,
  m,
  f,
  !1,
  null,
  null,
  null,
  null
);
const d = g.exports;
const v = {
  name: "NcAppNavigationToggle",
  components: {
    NcButton: o,
    MenuIcon: p,
    MenuOpenIcon: d
  },
  props: {
    open: {
      type: Boolean,
      required: !0
    }
  },
  emits: ["update:open"],
  computed: {
    label() {
      return this.open ? l("Close navigation") : l("Open navigation");
    }
  },
  methods: {
    toggleNavigation() {
      this.$emit("update:open", !this.open);
    }
  }
};
var h = function() {
  var t = this, e = t._self._c;
  return e("NcButton", { staticClass: "app-navigation-toggle", attrs: { type: "tertiary", "aria-expanded": t.open ? "true" : "false", "aria-label": t.label, title: t.label, "aria-controls": "app-navigation-vue" }, on: { click: t.toggleNavigation }, scopedSlots: t._u([{ key: "icon", fn: function() {
    return [t.open ? e("MenuOpenIcon", { attrs: { size: 20 } }) : e("MenuIcon", { attrs: { size: 20 } })];
  }, proxy: !0 }]) });
}, y = [], C = /* @__PURE__ */ i(
  v,
  h,
  y,
  !1,
  null,
  "8cb91920",
  null,
  null
);
const H = C.exports;
export {
  H as N
};
